<template>
    <div>
        <div class="header pt-5">
            <div>
                {{ headerText }}
            </div>
            <div>
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.employeeForm.cancel') }}
                </v-btn>

                <v-btn
                    @click="submit()"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.employeeForm.save') }}
                </v-btn>
            </div>
        </div>
            <v-form
                lazy-validation
                ref="form"
                v-model="valid">
                <v-container>
                    <v-row>
                        <v-col
                            cols="7"
                            class="pl-0">
                            <v-card class="content-container">
                                <v-container>
                                    <v-row>
                                        <v-col
                                            cols="12">
                                            <span class="headline ml-2">
                                                {{ $vuetify.lang.t('$vuetify.employeeForm.profile') }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="3">
                                            <div class="profile-company-image">
                                                <profile
                                                    :isEditing="isEditing"
                                                    @change-profile-img="changeProfileImg"
                                                    :img="faceImg"/>
                                            </div>
                                            <div class="image-size-info"><center>{{ $vuetify.lang.t('$vuetify.employeeForm.msgImageSize') }}</center></div>
                                        </v-col>
                                        <v-col cols="9">
                                            <v-container>
                                                <v-row>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            v-model="form.citizen_id"
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.citizenId')"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            :rules="inputRules"
                                                            :error-messages="errors.citizen_id"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            v-model="form.employee_no"
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.employeeNo')"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            :rules="employeeNoRules"
                                                            :error-messages="errors.employee_no"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.name')"
                                                            v-model="form.name"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            :rules="inputRules"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.surname')"
                                                            v-model="form.surname"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            :rules="inputRules"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        cols="6">
                                                        <label class="gender-label">{{ $vuetify.lang.t('$vuetify.employeeForm.gender') }}</label>
                                                        <v-radio-group
                                                            v-model="form.gender"
                                                            row
                                                            class="remove-margin"
                                                            :rules="inputRules"
                                                        >
                                                            <v-radio
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.male')"
                                                            value="M"></v-radio>
                                                            <v-radio
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.female')"
                                                            value="F"></v-radio>
                                                        </v-radio-group>
                                                    </v-col>
                                                    <v-col
                                                        cols="6">
                                                        <v-menu
                                                            ref="empBirthdayMenu"
                                                            v-model="datePickerShow"
                                                            :close-on-content-click="false"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    v-model="dateFormatted"
                                                                    :label="$vuetify.lang.t('$vuetify.employeeForm.dateOfBirth')"
                                                                    @click:prepend-inner="datePickerShow = true"
                                                                    prepend-inner-icon="event"
                                                                    readonly
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                :locale="localeLang"
                                                                ref="empBirthdayPicker"
                                                                v-model="form.date_of_birth"
                                                                :rules="inputRules"
                                                                :max="birthdayConfig.max"
                                                                :min="birthdayConfig.min"
                                                                @change="saveBirthday"
                                                            ></v-date-picker>
                                                        </v-menu>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        cols="6">
                                                        <v-select
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.department')"
                                                            v-model="form.department_id"
                                                            :items="departments"
                                                            :rules="inputRules"
                                                            item-text="name"
                                                            item-value="id">
                                                        </v-select>
                                                    </v-col>
                                                    <v-col
                                                        cols="6">
                                                        <v-text-field
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.branch')"
                                                            v-model="branch.name"
                                                            autocomplete="off"
                                                            readonly
                                                            placeholder=" ">
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        cols="6">
                                                        <v-autocomplete
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.group')"
                                                            v-model="form.group_id"
                                                            :items="groups"
                                                            :rules="groupInputRules"
                                                            item-text="name_with_workday"
                                                            item-value="id">
                                                        </v-autocomplete>
                                                    </v-col>
                                                    <v-col
                                                        cols="6">
                                                        <v-select
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.role')"
                                                            v-model="form.role"
                                                            :items="roles"
                                                            :rules="inputRules"
                                                            item-text="text"
                                                            item-value="value">
                                                        </v-select>
                                                    </v-col>
                                                </v-row>
                                                <!-- <v-row>
                                                    <v-col cols="12">
                                                        <v-autocomplete
                                                            v-model="form.employee_notices"
                                                            item-text="fullname"
                                                            item-value="id"
                                                            :items="employeeNotices"
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.employee_notices')"
                                                            multiple
                                                            small-chips
                                                        ></v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col :cols="operationMode === 'edit' ? 9 : 12">
                                                        <v-autocomplete
                                                            v-model="form.devices"
                                                            item-text="name"
                                                            item-value="id"
                                                            :items="devices"
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.device')"
                                                            multiple
                                                            small-chips
                                                        ></v-autocomplete>
                                                    </v-col>
                                                    <v-col v-if="operationMode === 'edit'" align-self="center" cols="3" >
                                                        <v-btn width="100%" color="primary" @click="syncEmployee"
                                                        >Sync</v-btn>
                                                    </v-col>
                                                </v-row> -->
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-col>
                        <v-col
                            cols="5"
                            class="pr-0">
                            <v-card class="content-container contact-card">
                                <v-container>
                                    <v-row>
                                        <v-col
                                            class="ml-2">
                                            <span class="headline">
                                                {{ $vuetify.lang.t('$vuetify.employeeForm.contact') }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="pt-2 pb-2">
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="6">
                                                        <v-text-field
                                                            v-model="form.email"
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.email')"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            :rules="emailRules"
                                                            :error-messages="errors.email"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <v-text-field
                                                            v-model="phoneNumberMask"
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.phoneNumber')"
                                                            autocomplete="off"
                                                            placeholder=" "
                                                            :error-messages="errors.phone_no"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                            <v-card class="mt-6 content-container">
                                <v-container>
                                    <v-row class="ml-2">
                                        <v-col cols="6">
                                            <v-row>
                                                <v-col>
                                                    <span class="headline">
                                                        {{ $vuetify.lang.t('$vuetify.employeeForm.employment') }}
                                                    </span>
                                                </v-col>
                                            </v-row>
                                            <v-row class="ml-0 mr-0 pt-2 pb-2">
                                                <v-radio-group
                                                    v-model="form.employment"
                                                    row
                                                    class="remove-margin"
                                                    :rules="inputRules">
                                                    <v-radio
                                                        v-for="sts in careerStatus"
                                                        :key="`cs${sts.value}`"
                                                        :label="sts.text"
                                                        :value="sts.value">
                                                    </v-radio>
                                                </v-radio-group>
                                            </v-row>
                                            <v-row class="ml-0 mr-0 pt-2 pb-2">
                                                <v-menu
                                                    ref="empStatusStartMenu"
                                                    v-model="stsStartDatePickerShow"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field
                                                            v-model="stsStartDateFormatted"
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.statusStart')"
                                                            prepend-icon="event"
                                                            readonly
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        :locale="localeLang"
                                                        ref="empStatusStartPicker"
                                                        v-model="form.status_start"
                                                        :rules="inputRules"
                                                        :min="statusDateConfig.min"
                                                        @change="saveStatusStart"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-row>
                                            <v-row class="ml-0 mr-0 pt-3 pb-status">
                                                <v-menu
                                                    ref="empStatusEndMenu"
                                                    v-model="stsEndDatePickerShow"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field
                                                            v-model="stsEndDateFormatted"
                                                            :label="$vuetify.lang.t('$vuetify.employeeForm.statusEnd')"
                                                            prepend-icon="event"
                                                            readonly
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        :locale="localeLang"
                                                        ref="empStatusEndPicker"
                                                        v-model="form.status_end"
                                                        :rules="inputRules"
                                                        :min="statusDateConfig.min"
                                                        @change="saveStatusEnd"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="6" class="status-image">
                                            <img :src="statusImage">
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        <div>
        </div>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import Profile from '@/components/Profile'
import imgPath from '@/assets/user_default.png'
import fulltimeImg from '@/assets/employee/fulltime.png'
import probationImg from '@/assets/employee/probation.png'

export default {
    name: 'EmployeeForm',

    directives: {
        mask
    },

    components: {
        Profile
    },

    data () {
        return {
            form: {
                name: '',
                surname: '',
                gender: '',
                date_of_birth: this.$util.getCurrentDate(),
                employee_no: '',
                citizen_id: '',
                email: '',
                phone_no: '',
                role: '',
                department_id: '',
                group_id: '',
                employment: '', //  possible value full time is 'FTM' and 'PBT'
                status_start: this.$util.getCurrentDate(),
                status_end: ''
                // employee_notices: '',
                // devices: ''
            },
            branch: {
                name: '',
                id: ''
            },
            currentLang: '',
            faceImg: imgPath,
            employeeId: '',
            operationMode: '',
            isChangeImage: false,
            same_image: false,
            statusImage: '',

            // array of select
            roles: [],
            departments: [],
            groups: [],
            employeeNotices: [],
            devices: [],

            // format data
            phoneNumberMask: '',
            nationalTelCode: '+66',
            datePickerShow: false,
            stsStartDatePickerShow: false,
            stsEndDatePickerShow: false,
            dateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            stsStartDateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            stsEndDateFormatted: '',
            birthdayConfig: {
                min: `${new Date().getFullYear() - 100}-01-01`,
                max: this.$util.getCurrentDate()
            },
            statusDateConfig: {
                min: `${new Date().getFullYear() - 100}-01-01`
            },

            // rules errors
            valid: true,
            emailRules: [
                vmail => this.$validator.hasValue(vmail, this.trans.employeeForm.msgRequiredEmail),
                vmail => this.$validator.lengthNotExceed(vmail, 255, this.trans.employeeForm.msgExceededEmail),
                vmail => this.$validator.correctFormat(vmail, /.+@.+\..+/, this.trans.employeeForm.msgInvalidEmailFormat)
            ],
            employeeNoRules: [
                v => this.$validator.lengthNotExceed(v, 255, this.trans.employeeForm.msgExceededField)
            ],
            inputRules: [
                v => this.$validator.hasValue(v, this.trans.employeeForm.msgRequiredField),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.employeeForm.msgExceededField)
            ],
            groupInputRules: [
                v => this.$validator.hasValue(v, this.trans.employeeForm.msgRequiredField),
                v => this.$validator.valueIn(v, this.groups, null, 'id', this.trans.employeeForm.msgRequiredField)
            ],
            phoneRules: [
                v => this.$validator.lengthExactly(v, 11, this.trans.employeeForm.msgIncorrectPhoneNumber)
            ],
            errors: [],
            isEditing: true
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        careerStatus () {
            return [
                {
                    text: this.trans.employeeForm.fullTime,
                    value: 'FTM'
                },
                {
                    text: this.trans.employeeForm.probation,
                    value: 'PBT'
                }
            ]
        },
        headerText () {
            let header = this.trans.employeeForm.createNewEmployee
            if (this.operationMode === 'edit') {
                header = this.trans.employeeForm.updateEmployee
            }
            return header
        },
        errorMsg () {
            return this.trans.employeeForm.msgError
        },
        imageSizeError () {
            return {
                title: this.errorMsg,
                text: this.trans.employeeForm.msgErrorImageSize,
                type: 'error'
            }
        },
        congratulationTitle () {
            return this.trans.employeeForm.congratulation
        },
        warningTitle () {
            return this.trans.employeeForm.warning
        },
        errorTitle () {
            return this.trans.employeeForm.error
        }
    },
    methods: {
        displayNoti (listMsg) {
            // for object to display response noti
            for (const property in listMsg) {
                let type = ''
                let title = ''
                if (listMsg[property].status === 'ok') {
                    title = this.congratulationTitle
                    type = 'success'
                } else if (listMsg[property].status === 'warning') {
                    title = this.warningTitle
                    type = 'warn'
                } else if (listMsg[property].status === 'error') {
                    title = this.errorTitle
                    type = 'error'
                }
                this.$notify({
                    title: title,
                    text: listMsg[property].msg,
                    type: type
                })
            }
        },

        checkRespose (res) {
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                const listMsg = res.data.data
                this.displayNoti(listMsg)

                this.$router.push({ name: 'Employees' }, () => {})
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.errorMsg,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async getRolesConstant () {
            const res = await this.axios.get('employee/roles')
            if (res && res.data && res.data.status === 'ok') {
                this.roles = res.data.roles
            }
        },

        async getDepartments () {
            const res = await this.axios.get('department/getAll')
            if (res && res.data && res.data.status === 'ok') {
                this.departments = res.data.data
            }
        },

        async getBranch () {
            const currentBranch = this.$store.state.branches.find((branch) => branch.id === parseInt(localStorage.getItem('currentBranchId')))
            this.branch = currentBranch
            if (this.branch.name) {
                this.groups = await this.$util.getGroups(this.branch.id)
            }
        },

        // async getEmployeeNotice () {
        //     let url = 'employees/filter'
        //     const role = 'HDP' // fix
        //     if (role && role != null) url += `?role=${role}`
        //     const res = await this.axios.get(url)
        //     if (res && res.data && res.data.status === 'ok') {
        //         this.employeeNotices = res.data.data
        //     }
        // },

        // async getDevice () {
        //     let url = 'devices/getAll'
        //     if (this.branch.id && this.branch.id != null) url += `?branch_id=${this.branch.id}`
        //     url += `&canUpload=${true}`
        //     const res = await this.axios.get(url)
        //     if (res && res.data && res.data.status === 'ok') {
        //         this.devices = res.data.data
        //     }
        // },

        changeProfileImg (event) {
            const fileList = event.target.files
            const maxFileSize = 200000
            const minFileSize = 25000

            const reader = new FileReader()
            let imgBase64 = null
            if (fileList[0] && (fileList[0].size < minFileSize || fileList[0].size > maxFileSize)) {
                this.$notify(this.imageSizeError)
            } else {
                if (fileList[0]) {
                    reader.onload = async () => {
                        imgBase64 = reader.result

                        this.faceImg = imgBase64
                        this.isChangeImage = true
                    }
                    reader.readAsDataURL(fileList[0])
                }
            }
        },

        displayStatusImage (key) {
            if (key === 'FTM') {
                this.statusImage = fulltimeImg
            } else if (key === 'PBT') {
                this.statusImage = probationImg
            }
        },

        async syncEmployee () {
            this.$store.dispatch('setLoading', true)
            const url = `employee/${this.employeeId}/sync`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: 'Congratulation',
                    text: 'Sync Successfully!',
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: 'Error message',
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        saveBirthday (date) {
            this.$refs.empBirthdayMenu.save(date)
            this.dateFormatted = this.$util.formatDate(date)
        },

        saveStatusStart (date) {
            this.$refs.empStatusStartMenu.save(date)
            this.stsStartDateFormatted = this.$util.formatDate(date)
        },

        saveStatusEnd (date) {
            this.$refs.empStatusEndMenu.save(date)
            this.stsEndDateFormatted = this.$util.formatDate(date)
        },

        cleanForm () {
            const keys = ['citizen_id', 'employee_no', 'name', 'surname', 'email']
            for (let i = 0; i < keys.length; i++) {
                this.form[keys[i]] = this.form[keys[i]].trim()
            }
        },

        submit () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.cleanForm()

            // check image is change
            if (this.isChangeImage) {
                this.same_image = false
                this.form = { ...this.form, image: this.faceImg }
            }

            this.form.phone_no = `${this.phoneNumberMask}`
            if (this.operationMode === 'create') {
                this.createEmployee()
            } else if (this.operationMode === 'edit') {
                this.updateEmployee()
            }
        },

        async createEmployee () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('employee/create', this.form)
            this.checkRespose(res)
        },

        async updateEmployee () {
            // check update image
            this.form = { ...this.form, same_image: this.same_image }

            this.$store.dispatch('setLoading', true)
            const url = `employee/edit/${this.employeeId}`
            const res = await this.axios.put(url, this.form)
            this.checkRespose(res)
        },

        async getEmployee (id) {
            this.$store.dispatch('setLoading', true)
            const url = `employee/${id}`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)

                const data = res.data.data
                this.form = {
                    name: data.name,
                    surname: data.surname,
                    gender: data.gender,
                    date_of_birth: data.date_of_birth,
                    employee_no: data.employee_no,
                    citizen_id: data.citizen_id,
                    email: data.email,
                    phone_no: data.phone_no,
                    role: data.role,
                    department_id: data.department,
                    group_id: data.group,
                    employment: data.employment,
                    status_start: data.status_start,
                    status_end: data.status_end,
                    employee_notices: data.employee_notices,
                    devices: data.devices
                }
                this.dateFormatted = this.$util.formatDate(data.date_of_birth)
                this.stsStartDateFormatted = this.$util.formatDate(data.status_start)
                this.stsEndDateFormatted = this.$util.formatDate(data.status_end)
                this.displayStatusImage(data.status)

                // remove '+66'
                this.phoneNumberMask = data.phone_no
                if (data.f_path) {
                    this.faceImg = data.f_path
                    this.same_image = true
                }
            }
        },

        cancel () {
            this.$router.push({ name: 'Employees' }, () => {})
        },

        initEmployeeStatus () {
            this.form.employment = 'FTM'
            this.displayStatusImage(this.form.employment)
        }
    },

    watch: {
        'form.employment': function (newValue, oldValue) {
            this.displayStatusImage(newValue)
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getRolesConstant()
                this.$util.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    },

    created () {
        this.registerLang({
            employeeForm: [
                'msgRequiredEmail',
                'msgInvalidEmailFormat',
                'msgExceededEmail',
                'msgExceededField',
                'msgRequiredField',
                'msgIncorrectPhoneNumber',
                'fullTime',
                'probation',
                'createNewEmployee',
                'updateEmployee',
                'msgError',
                'msgErrorImageSize',
                'congratulation',
                'warning',
                'error'
            ]
        })
    },

    async mounted () {
        this.employeeId = this.$route.params.id
        this.currentLang = this.$vuetify.lang.current
        if (this.employeeId) {
            await this.getEmployee(this.employeeId)
            this.operationMode = 'edit'
        } else {
            this.operationMode = 'create'
            this.initEmployeeStatus()
        }

        await this.getBranch()
        await this.getRolesConstant()
        await this.getDepartments()
        // await this.getEmployeeNotice()
        // await this.getDevice()
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .action-header {
        display: flex;

        .btn-action {
            margin: 1rem;
        }
    }
}
.gender-label {
    font-size: 12px;
    color: grey;
}
.remove-margin {
    margin-top: 0px;

    @media only screen and (max-width: 1450px) {
        .v-radio {
            margin-right: 8px;
        }
    }
}
.profile-company-image {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
}
.image-size-info {
    font-size: 9px;
    color: gray;
}
.status-image {
    img {
        height: 270px;
    }
}
.pb-status {
    padding-bottom: 24px !important;
}
@media only screen and (max-width: 1689px) {
    .status-image {
        padding-left: 0px;
    }

    .pb-status {
        padding-bottom: 0px !important;
    }
}
</style>
